import { Autocomplete as MuiAutocomplete, Stack, TextField, Typography } from '@mui/material';
import React from 'react';
import { useController, useFormContext } from 'react-hook-form';
import { CssTextField } from './CssTextField';
import ColumnLabel from './ColumnLabel';

interface AutocompleteProps {
    name: string;
    label?: string;
    options?: any[];
    noOptionsText?: string;
    onInputChange?: (e: React.SyntheticEvent, value: string) => void;
    labelName?: string;
}

const Autocomplete = (props: AutocompleteProps) => {
    const { name, label, options, onInputChange, noOptionsText, labelName, disabled } = props;
    const { field } = useController({ name: name });
    const form = useFormContext();

    return (
        <MuiAutocomplete
            disabled={disabled}
            options={options || []}
            autoComplete
            autoHighlight
            getOptionLabel={(option) => {
                return labelName ? option[labelName] : option.label;
            }}
            isOptionEqualToValue={(option, value) => option.id === value.id}
            value={field.value || null}
            onChange={(_, value) => {
                field.onChange(value);
            }}
            renderOption={(props, option) => (
                <li {...props} key={option.id}>
                    {option[labelName]}
                </li> // Ensure unique key
            )}
            filterOptions={(x) => x}
            noOptionsText={noOptionsText}
            onInputChange={onInputChange}
            renderInput={(params) => {
                const customParams = { ...params, InputProps: { ...params?.InputProps, disableUnderline: true }, fixedPadding: 7.5 };
                return (
                    <Stack sx={{ marginTop: 0.1 }}>
                        <ColumnLabel label={label} />
                        <CssTextField
                            variant="standard"
                            {...customParams}
                            fullWidth
                            size="small"
                            error={form?.formState?.errors?.[`${name}.id`] ?? form?.formState?.errors?.[name]}
                            helperText={form?.formState?.errors?.[`${name}.id`]?.message ?? form?.formState?.errors?.[name]?.message}
                        />
                    </Stack>
                );
            }}
        />
    );
};

export default Autocomplete;
